const Experience = () => {
  return (
    <>
      <div style={{ height: '65px' }} id='experience'></div>
      <div className='container card shadow p-4'>
        <div className='row'>
          <div className='col px-4 justify-content-center'>
            <h3 className='text-center'>Experience</h3>
            <hr />
            <h5>Om Informatics</h5>
            <hr />
            <h6>Dec 2025 To Present</h6>
            <ul>
  
              <br />
                 <li>Worked as Asp.net Developer</li> 
                  <br />
                  <li>Worked on ERP Systems</li> 
                  <br />
                  <li>Worked on MVP, New Modules to Convert into .Net Core</li>

            </ul>


            <hr />  
            <hr />
            <h5>Generali Central Insuarance (Future Generali India Insuarance)</h5>
            <hr />
            <h6>Jan 2022 To Nov 2025</h6>
            <ul>
  
              <br />
                 <li>Worked as Asp.net Developer</li> 
                  <br />
                  <li>Worked on Business Projects, HR Projects,Client APIs, API Gateways tools like WSO2, GitHub Actions, CICD Deployments, etc</li> 
                  <br />
                  <li>Worked on Asp.net Frameworks 4.5+, WebForms, WinForms, .Net Core WebAPIs, API Integration, WCF Services </li>
                  <br />
                  <li>Worked on Vulnerability Assessments and its Fixes</li>
            </ul>


            <hr />           

 
            <div className='text-center p-2'>
              <button type='button' className='btn btn-primary rounded-0'>
                <a
                  href='https://github.com/pra958'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-decoration-none text-white'
                >
                  Visit GitHub Profile
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Experience;
